/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_StudiengangInputs */

const de__field_studiengang = /** @type {(inputs: _Field_StudiengangInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studiengang`)
};

/**

* @param {_Field_StudiengangInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_studiengang = /** @type {((inputs?: _Field_StudiengangInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_StudiengangInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_studiengang(inputs)
});